import { AnyToken } from 'src/common/types/models/Tokens'
import { ZERO } from '../big-utils'
import { uniqBy } from 'lodash'

export const aggregateNFTCollection = (tokens: AnyToken[]): AnyToken[] => {
  const nftBalances = new Map<string, Big>()

  tokens.forEach(({ type, contractAddress, balance }) => {
    if (type !== 'ERC20') {
      const currentBalance = nftBalances.get(contractAddress) || ZERO
      nftBalances.set(contractAddress, currentBalance.plus(balance || ZERO))
    }
  })

  return uniqBy(tokens, 'contractAddress').map(token => {
    const totalBalance = nftBalances.get(token.contractAddress) || token.balance
    return {
      ...token,
      balance: totalBalance,
    }
  })
}
